import useCall from '../../hooks/redux/useCall';
import useChatConnections from '../../hooks/redux/useChatConnections';
import React from 'react';
import ContactsList from './ContactList';
import User from 'views/Home/User';
import IncomingContact from './IncomingContact';
import './top-bar.scss';
import useTaskConnections from 'hooks/redux/useTaskConnections';
import LoginTimerPopUp from './loginTimerPopUp';
import popoutIcon from './popout.svg'
import { useSelector } from 'react-redux';
import RootState from 'store/state';
import { ExternalIframeConfiguration } from 'store/app/app.state';
import { AppFeatures, useCompanyHasFeature } from 'hooks/useHasFeature';

interface Props {
    pathname: string;
    showIncoming: boolean;
}

const Header: React.FC<Props> = ({ showIncoming }) => {
    const call = useCall();
    const incomingChat = useChatConnections("incoming");
    const incomingTask = useTaskConnections("incoming");
    const blockStatusChange = useSelector<RootState, boolean | undefined>(
      (state) => state.user.statusControl?.blockStatusChange
    );
    const externalIframeConfiguration = useSelector<RootState, ExternalIframeConfiguration | undefined>(state => state.app.appConfig.externalIframeConfiguration)   
    const companyHasFeature = useCompanyHasFeature()
    const shouldBlockMultipleBrowserTabs = companyHasFeature(AppFeatures.BLOCK_MULTIPLE_BROWSER_TABS);

    const getActive = () => {
        if (call) return {
            channel: "VOICE" as const,
            call: call
        }

        if (incomingChat) return {
            channel: "CHAT" as const,
            chat: incomingChat
        }

        if(incomingTask) return {
            channel: "TASK" as const,
            task: incomingTask
        }

        return;
    }

    return (
      <>
        {externalIframeConfiguration && (
          <iframe
            style={
              externalIframeConfiguration.isVisible ? {} : { display: "none" }
            }
            id="external-iframe"
            src={externalIframeConfiguration.url}
            title={externalIframeConfiguration.name}
          />
        )}
        <header className={"sa-top-bar"}>
          <LoginTimerPopUp />

          <div className={"sa-top-bar_wrapper"}>
            {showIncoming && !call?.inCall ? (
              <IncomingContact active={getActive()} />
            ) : (
              <>
                <User blockStatusChange={blockStatusChange} />

               {!shouldBlockMultipleBrowserTabs && 
                <a
                    className="sa-lite-popout"
                    href={window.location.href}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={popoutIcon}
                      alt="Open SmartAgent in new tab"
                      title="Open SmartAgent in new tab"
                    />
                  </a>
                }
              </>
            )}
          </div>

          <ContactsList />
        </header>
      </>
    );
}

export default Header

